module.exports = __webpack_public_path__ + "img/gameit.0cb37a9d.webp";